import React, { Component } from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import ReactYouTube from "react-youtube"
import { addResponsivity, up, down, between } from "../lib/styles"
import { Col, Row, Text, Title, Gap, Link, RoundWrapper } from "."

import playIconPath from "../data/images/icon-play.svg"

const Wrapper = styled.div`
  position: relative;
`

const YoutubeWrapper = styled(RoundWrapper)`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
  margin-top: 24px;

  iframe {
    /* width: 100%;
    height: 330px;
    display: flex; */
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`
const PlayIcon = styled.img`
  ${({ isPlaying, hidden }) => css`
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 3;
    transform: translate(-50%, -50%) scale(1.35);
    margin: 10px 0 0;
    cursor: pointer;
    opacity: ${isPlaying || hidden ? 0 : 1};
    display: ${isPlaying || hidden ? "none" : "block"};
    transition: 0.3s;
  `}
`

class Youtube extends Component {
  state = {
    ytLoaded: false,
    ytState: -1,
  }

  playVideo = () => {
    this.player.playVideo()
    this.setState({ isPlaying: true })
  }

  render() {
    const { videoId } = this.props
    const { ytLoaded, ytState } = this.state

    const isPlaying = ytState === 1

    return (
      <Wrapper>
        <YoutubeWrapper>
          <ReactYouTube
            videoId={videoId}
            opts={{
              playerVars: {
                // https://developers.google.com/youtube/player_parameters
                modestbranding: 1,
                controls: 0,
                rel: 0,
              },
            }}
            onReady={event => {
              this.player = event.target
              this.setState({ ytLoaded: true })
            }}
            onStateChange={event => {
              this.setState({ ytState: event.data })
            }}
          />
        </YoutubeWrapper>
        <PlayIcon
          src={playIconPath}
          onClick={this.playVideo}
          isPlaying={isPlaying}
          hidden={!ytLoaded}
        />
      </Wrapper>
    )
  }
}

Youtube.propTypes = {}

export default Youtube
